import { StatementDetailFilter, StatementDTO, StatementFilter, StatementRecordDTO } from '../../interface/bets';
import { createAsyncThunk, createSelector, createSlice, isAnyOf } from '@reduxjs/toolkit';
import { RootState } from '../types';
import { BetsAPI } from '../../apis/bets';

interface StatementState {
  list: StatementDTO[];
  detail: Record<number, StatementRecordDTO[]>;
  mapIdToCurrentDate: Record<number, number>;
  isLoading: boolean;
}

const initialState: StatementState = {
  list: [],
  detail: {},
  mapIdToCurrentDate: {},
  isLoading: false,
} as StatementState;

export const doGetStatement = createAsyncThunk('statement/getAll', async (filter: StatementFilter, { getState }) => {
  const state = getState() as RootState;
  const userInfo = state.user;
  if (userInfo?.Uuid) {
    const Data = await BetsAPI.getStatement(filter, userInfo);

    return Data;
  }

  return [] as StatementDTO[];
});

export const doGetStatementDetail = createAsyncThunk(
  'statement/getDetail',
  async (filter: StatementDetailFilter, { getState }) => {
    const state = getState() as RootState;
    const userInfo = state.user;
    if (userInfo?.Uuid) {
      const Data = await BetsAPI.getStatementDetail(filter, userInfo);

      return Data;
    }

    return [] as StatementRecordDTO[];
  }
);

export const statementSlice = createSlice({
  name: 'result',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(doGetStatement.fulfilled, (state, action) => {
        if (action.payload) state.list = action.payload;

        state.isLoading = false;
      })
      .addCase(doGetStatementDetail.fulfilled, (state, action) => {
        if (action.payload) state.detail[action.meta.arg.CurrentDate] = action.payload;

        // populate data to mapIdToCurrentDate
        for (let i = 0; i < action.payload.length; i++) {
          state.mapIdToCurrentDate[action.payload[i].Id] = action.meta.arg.CurrentDate;
        }

        state.isLoading = false;
      })
      .addMatcher(isAnyOf(doGetStatement.pending, doGetStatementDetail.pending), (state) => {
        state.isLoading = true;
      });
  },
});

export default statementSlice.reducer;

export const selectStatementRecord = createSelector(
  (state: RootState) => state.myAccount.statement.detail,
  (state: RootState) => state.myAccount.statement.mapIdToCurrentDate,
  (state: RootState, id: number) => id,
  (detail, mapIdToCurrentDate, id) => {
    return detail[mapIdToCurrentDate[id]]?.find((record) => record.Id === id);
  }
);
